/* eslint-disable */
import axios from 'axios';

const API_URL = 'https://bewowebapirecipetool.azurewebsites.net/api/UserRole'; // Replace with your actual API endpoint

// Updated function to get the JWT token from localStorage
function getJwtToken() {
  // Updated to match the storage key used in authService.js
  return localStorage.getItem('token');
}

// Function to fetch all users with JWT token
export async function getUsers() {
  const token = getJwtToken();
  try {
    const response = await axios.get(`${API_URL}/user`, { // Use template literal for consistency
      headers: {
        Authorization: `Bearer ${token}`, // Use Bearer token authorization
      },
    });
    return response.data; // Assuming the API returns the list of users directly
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error; // Rethrow the error to be handled by the caller
  }
}

export async function addUser(userData) {
  const token = getJwtToken(); // Make sure you have a function to retrieve the JWT token
  try {
    const response = await axios.post(`${API_URL}/user`, userData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error adding user:', error);
    throw error;
  }
}

export async function deleteUser(userId) {
  const token = getJwtToken(); // Make sure this function exists to get the JWT token
  try {
    const response = await axios.delete(`${API_URL}/user/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // Depending on your API, this might be confirmation of deletion
  } catch (error) {
    console.error('Error deleting user:', error);
    throw error;
  }
}

